/**
 * can(user, key) — IDI-762: the client copy of the server's TenantContext.Can
 * (backend-go/pkg/middleware). Plain JS: never import AuthContext,
 * SuperAdminGuard or aws-amplify here (jest can't parse amplify).
 *
 *   - roles = user.groups when non-empty, else user.role split by commas
 *     (a group outranks custom:role, as on the server)
 *   - admin (not a field tech) or super_admin / idi_admin → no toggles (D1)
 *   - otherwise only a saved false refuses (D2)
 */
const norm = (r) => (typeof r === 'string' ? r.trim().toLowerCase() : '');

function rolesOf(user) {
  const groups = Array.isArray(user.groups) ? user.groups.map(norm).filter(Boolean) : [];
  return groups.length ? groups : String(user.role ?? '').split(',').map(norm).filter(Boolean);
}

export function isPermissionExempt(user) {
  if (!user || typeof user !== 'object') return false;
  const roles = rolesOf(user);
  if (roles.some((r) => r === 'super_admin' || r === 'idi_admin')) return true;
  if (typeof user.tenantId === 'string' && user.tenantId.toUpperCase() === 'IDI') return true;
  if (roles.some((r) => r === 'field_tech' || r === 'field_technician')) return false;
  return roles.includes('admin');
}

export function can(user, key) {
  if (isPermissionExempt(user)) return true;
  const perms = user && user.permissions;
  if (!perms || typeof perms !== 'object') return true;
  return perms[key] !== false;
}

export default can;
